<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="flex flex-col grid-toolbar-buttons-group-container w-p-100 justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="flex flex-col justify-center items-start grid-toolbar-buttons-group-container">
      <label class="component-label"> Actions</label>

      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="createReport()" particleAnalytics
                  analyticsCategory="entity-transactions-content" analyticsAction="add-section">Add Report
          </button>
          <div class="toolbar-separator"></div>
        </div>
        <!--        <div class="button-container" class="flex flex-row" fxLayoutAlign="start center">-->
        <!--          <button mat-button class="orbitax-flat-button" (click)="applyFilter()" particleAnalytics-->
        <!--                  analyticsCategory="entity-transactions-content" analyticsAction="add-section">Apply Filter-->
        <!--          </button>-->
        <!--          <div class="toolbar-separator"></div>-->
        <!--        </div>-->
        <!--        <div class="button-container" class="flex flex-row" fxLayoutAlign="start center">-->
        <!--          <button mat-button class="orbitax-flat-button" [disabled]="true" (click)="deleteReport('')" particleAnalytics-->
        <!--                  analyticsCategory="entity-transactions-content" analyticsAction="add-section">Delete-->
        <!--          </button>-->
        <!--          <div class="toolbar-separator"></div>-->
        <!--        </div>-->
      </div>
    </div>
    <!--    <div class="group-buttons">-->
    <!--      <button  mat-button class="grid-button"-->
    <!--               particleAnalytics-->
    <!--               analyticsCategory="projects-content"-->
    <!--               analyticsAction="relevant links"-->
    <!--               (click)="navigateToItrce()"><span>Open Legacy ITRCE</span> <i class="fal fa-sign-in m-l-5"></i>-->
    <!--      </button>-->
    <!--    </div>-->
  </div>


  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->

        <!----------------------EMPTY VIEW START --------------------------->


        <div *ngIf="recordCount === 0" class="empty-content flex flex-col justify-center items-center flex-1-0-100">

          <div class="text-container">
            <img
              src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/reports-empty.png"
              alt="Empty images">
            <h1>Add FX Rates Report</h1>
            <div class="text">Use the <a (click)="createReport()">Add Report</a> screen to create your FX Rates report,
              where you can specify the Rate Type, Dates and Reporting/Translation Currencies.
            </div>
          </div>
        </div>

        <!----------------------EMPTY VIEW END --------------------------->

        <div class="content  pos-relative m-30 flex flex-col full-grow-no-shrink-no-basis">
          <div class="keno-grid-container">
            <particle-virtual-grid *ngIf="this.isDataLoaded" [sourceKey]="sourceType"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
                                   [sortFieldKey]="sortFieldKey"
                                   [sortDirection]="sortDirection"
                                   (recordCountChanged)="onRecordCountChange($event)"
            >
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>

  </mat-sidenav-container>

</div>
